"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationPatch = void 0;
class ApplicationPatch {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ApplicationPatch.attributeTypeMap;
    }
}
exports.ApplicationPatch = ApplicationPatch;
ApplicationPatch.discriminator = undefined;
ApplicationPatch.attributeTypeMap = [
    {
        "name": "metadata",
        "baseName": "metadata",
        "type": "{ [key: string]: string; }",
        "format": ""
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    },
    {
        "name": "rateLimit",
        "baseName": "rateLimit",
        "type": "number",
        "format": "uint16"
    },
    {
        "name": "uid",
        "baseName": "uid",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ApplicationPatch.js.map